import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Loader from "designs/v1/pages/ModifyKyc/components/Loader";
import { verifyDgLockerApi } from "designs/v1/pages/ModifyKyc/services";

const ReKycDigilockerDetails = () => {
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const token = params.get("code");
    const doc_name = localStorage.getItem("AddressRequestNumber");
    const verifyDgLocker = async () => {
      setIsLoading(true);
      try {
        const resp = await verifyDgLockerApi({ token, doc_name });
        console.log("resp", resp);
        setIsLoading(false);
        window.location.href = "modify-kyc";
        localStorage.setItem("isDigilocker", true);
      } catch (error) {
        const { data } = error.response || {};
        toast.error(
          data.message?.message || "Internal server error!"
        );
        setIsLoading(false);
      }
    };
    verifyDgLocker();
  }, []);
  if (isLoading) return <Loader />;
  return null;
};

export default ReKycDigilockerDetails;
